<template>
  <div>
    <v-container style="max-width: unset" class="pa-4">
      <v-expansion-panels
          v-model="panel"
          class="mb-4"
      >
        <v-expansion-panel
            class="elevation-0"
        >
          <v-expansion-panel-header class="ma-1 pa-1">
            <section class="d-flex align-center">
              <v-icon s size="40"   color="#369023">
                mdi-reload
              </v-icon>

              <h2>Atualização em massa</h2>
            </section>
            <template v-slot:actions>
              <v-icon size="40">
                mdi-chevron-down
              </v-icon>
            </template>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-row cols="12" class="pa-0 ma-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="pa-0 ma-0 my-2">
                <strong>Cadastro de SKU</strong> <br/>
                <span>Cadastre novos SKUs de produtos ou faça alterações dos atributos</span>
              </v-col>
              <v-col  cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="pa-0 ma-0  pt-4 d-flex justify-space-around align-center">
                <v-btn
                    outlined
                    height="40"
                    class="config-button mb-3"
                    @click="importExcel()"
                >
                  <v-icon class="ma-0 mr-1 pa-0">mdi-cloud-upload-outline</v-icon>
                  <span> Importar produtos </span>
                </v-btn>

                <v-btn
                    dark
                    elevation="0"
                    height="40"
                    class="add-button mb-3"
                    @click="goToRoute('/add-product')"
                >
                  Adicionar produto
                </v-btn>
              </v-col>

              <v-col cols="12" class="pa-0 ma-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row cols="12" class="pa-0 ma-0">
              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="pa-0 ma-0 my-2">
                <strong>Preço de venda</strong> <br/>
                <span>Atualize todos os preços e SKUs de venda dos produtos</span>
              </v-col>
              <v-col  cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="pa-0 ma-0  pt-4 d-flex justify-space-around align-center">
                <v-btn
                    outlined
                    height="40"
                    class="config-button mb-3"
                    @click="generateSkusExcel()"
                >
                  <span>Exportar SKUs </span>
                </v-btn>

                <v-btn
                    outlined
                    height="40"
                    class="config-button mb-3"
                    @click="openFilePicker()"
                >
                  <span>Importar SKUs</span>
                </v-btn>
              </v-col>

              <v-col cols="12" class="pa-0 ma-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <input
          id="excelSkusInput"
          name="excelSkusInput"
          ref="excelSkusInput"
          type="file"
          accept=".xlsx,.xlsm"
          style="display: none"
          @change="setExcelFile"
      />

      <v-card
        transition="scale-transition"
        v-if="true"
        class="d-column mt-0 mb-6 py-0"
        elevation="0"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <!-- Primeira linha de filtro -->
        <v-row class="pa-0 ma-0">
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="3"
            sm="6"
          >
            <v-text-field
              outlined
              class="px-0"
              style="
                border: 1px solid #979797;
                border-radius: 7.5px;
                width: 100%;
              "
              color="black"
              background-color="#F5F5F5"
              hide-details
              placeholder="Nome do Produto ou SKU"
              v-model="filter.product"
              attach
              :loading="loading"
            >
              <template v-slot:append>
                <v-icon
                  @click="filterTable"
                  class="pt-0"
                  color="normalred"
                  size="26"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.productCategory"
              attach
              :items="categories"
              item-text="categoryName"
              item-value="categoryId"
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Categoria"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              color="black"
              clearable
              v-model="filter.productType"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Tipo"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            xl="3"
            lg="3"
            md="4"
            sm="6"
          >
            <v-btn
              :outlined="!showAllFilters"
              block
              color="black"
              dark
              elevation="0"
              height="56"
              style="border-radius: 7.5px"
              @click="showAllFilters = !showAllFilters"
            >
              <v-icon class="ma-0 pa-0">mdi-filter</v-icon>
              Abrir todos os filtros
            </v-btn>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            xl="2"
            lg="2"
            md="2"
            sm="6"
          >
            <v-btn
              block
              outlined
              height="56"
              style="border-radius: 7.5px"
              @click="reset"
              >Limpar filtros
            </v-btn>
          </v-col>
          <v-col
            v-if="!showAllFilters"
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            xl="2"
            lg="2"
            md="2"
            sm="6"
          >
            <v-btn
              block
              outlined
              height="56"
              style="border-radius: 7.5px"
              @click="filterTable"
              >Buscar
            </v-btn>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              clearable
              v-model="filter.productApplication"
              attach
              outlined
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Aplicação"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="4"
            v-if="showAllFilters"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.status"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'Ativo', value: 1 },
                { text: 'Inativo', value: 0 },
              ]"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Status"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              v-model="filter.maxValue"
              :key="maxValueKey"
              v-money="money"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Valores Até"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.order"
              :items="orders"
              item-text="text"
              item-value="value"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Ordem alfabetica"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              v-model="filter.value"
              v-money="money"
              :key="valueKey"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Valor"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.ProductSubCategory"
              :items="subCategories"
              item-text="name"
              item-value="subCategoryId"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Subcategoria"
              placeholder="Subcategoria"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>
          <v-col
            v-if="showAllFilters"
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            xl="2"
            lg="2"
            md="2"
            sm="6"
          >
            <v-btn
              block
              outlined
              height="56"
              style="border-radius: 7.5px"
              @click="filterTable"
              >Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- Tabela -->
      <v-data-table
        id="productTable"
        class="elevation-3 content-table"
        style="overflow-wrap: anywhere"
        loading-text="Carregando..."
        no-data-text="Nenhum produto encontrado"
        hide-default-footer
        :headers="headers"
        :items="products"
        :loading="loading"
        :items-per-page="pageSize"
        :header-props="headerProps"
        v-model="selectedProducts"
        show-select
        item-key="productId"
        :single-select="false"
      >
        <template v-slot:[`header.download`]="{ header }">
          <v-btn
            outlined
            tile
            icon
            width="35"
            height="35"
            v-on="header"
            class="quinary-button"
            style="border-radius: 5px"
            @click="exportExcel"
          >
            <v-icon>mdi-download-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.productPic`]="{ item }">
          <div class="d-flex pa-3">
            <v-img
              :src="item.productPic"
              :alt="item.productName"
              class="imgProduct"
              width="80"
              height="50"
            ></v-img>
          </div>
        </template>

        <template v-slot:[`item.productName`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div class="product-name-field" v-on="on">
                {{ item.productName }}
              </div>
            </template>
            <span>{{ item.productName }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.productSku`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div
                class="product-name-field sku-name"
                v-on="on"
                style="max-width: 220px !important"
              >
                {{ item.productSku }}
              </div>
            </template>
            <span>{{ item.productSku }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.categories`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div
                class="product-name-field long-name"
                v-on="on"
                style="max-width: 220px !important"
              >
                {{
                  item.categories.length > 0
                    ? item.categories[0].category.categoryName
                    : "Sem registros"
                }}
              </div>
            </template>
            <span>{{
              item.categories.length > 0
                ? item.categories[0].category.categoryName
                : "Sem registros"
            }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.price`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div
                class="product-name-field short-name"
                v-on="on"
                style="max-width: 240px !important"
              >
                R$ {{ item.price.toFixed(2).replace(".", ",") }}/m
              </div>
            </template>
            <span>R$ {{ item.price.toFixed(2).replace(".", ",") }}/metro</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.vendas`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div
                class="product-name-field short-name"
                v-on="on"
                style="max-width: 110px !important"
              >
                {{ item.vendas }}
              </div>
            </template>
            <span>{{ item.vendas }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <div class="d-flex pa-0 ma-0">
            <v-select
              :loading="statusLoading"
              class="ma-3 pa-0"
              style="width: 110px !important"
              hide-details
              dense
              outlined
              :items="status"
              @change="changeStatus(item)"
              item-text="label"
              item-value="value"
              v-model="item.status"
            >
              <template v-slot:selection="{ item }">
                <span class="normal">{{ item.label }}</span>
              </template>
            </v-select>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div style="display: flex; flex-direction: row; flex-wrap: nowrap">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  style="border-radius: 4px"
                  width="76"
                  height="35"
                  class="ma-1 table-button hidden-sm-and-down"
                  color="quaternary"
                  @click="detailsProduct(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>Detalhar</span>
                </v-btn>
              </template>
              <span>Detalhes</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="76"
                  height="35"
                  small
                  class="table-button ma-1 hidden-md-and-up"
                  color="quaternary"
                  @click="detailsProduct(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>Detalhar</span>
                </v-btn>
              </template>
              <span>Detalhar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 table-button"
                  color="quaternary"
                  @click="editProduct(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 remove-button"
                  color="red"
                  @click="deleteProduct(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template
                v-if="userlogged.type == 2 ? true : false"
                v-slot:activator="{ on, attrs }"
              >
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 6px"
                  small
                  class="ma-1 table-button"
                  color="quaternary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-clock-check-outline</v-icon>
                </v-btn>
              </template>
              <span>Histórico</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
          <v-simple-checkbox
              :ripple="false"
              @click="addProductsListSelectedProducts(item)"
              :value="isSelected"
              color="#bc0000"
              v-bind="props"
              v-on="on"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:header.data-table-select="{ on, props}">
          <v-simple-checkbox
              color="#bc0000"
              v-bind="props"
              v-on="on"
              :ripple="false"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:footer >
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>

          <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedProducts.length > 0">
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="ma-0 pa-0 pa-0 mb-0">
              <label>Selecione a ação</label>
              <v-select
                  class="ma-0 pa-0 "
                  dense
                  v-model="action"
                  outlined
                  style="border-radius: 3px!important"
                  :items="actions"
                  item-text="label"
                  item-value="value"
                  placeholder="Selecione a ação"
              >
              </v-select>

              <section v-if="action === 6 || action === 7 || action === 8 || action === 9 ">
                <label>Selecione o tipo de atualização de preço</label>
                <v-select
                    class=""
                    dense
                    v-model="percentageOrReal"
                    outlined
                    style="border-radius: 3px!important"
                    :items="subActions"
                    item-text="label"
                    item-value="value"
                    placeholder="Selecione o tipo de atualização de preço"
                    @change="setSubActions()"
                >
                </v-select>
              </section>

              <section v-if="percentageOrReal && (action === 6 || action === 7 || action === 8 || action === 9)">
                <section >
                  <label class="ml-1 mb-2 label-details">Valor</label>
                  <section style="border: 1px solid #979797; border-radius: 7.5px; width: 100%;!important;">
                    <vuetify-money
                        color="black"
                        v-bind:outlined="outlined"
                        placeholder="0.0"
                        required
                        dense
                        hide-details
                        style="height: 40px!important"
                        v-model="value"
                        v-bind:options="options"
                    >
                    </vuetify-money>
                </section>
                </section>
              </section>

              <section v-if="action === 10">
                <section >
                  <label class="ml-1 mb-2 label-details">Porcentagem</label>
                  <v-text-field
                      style="border-radius: 7.5px"
                      outlined
                      suffix="%"
                      dense
                      height="40"
                      hide-details
                      v-mask="'##'"
                      v-model="promotionPercentage"
                  ></v-text-field>
                </section>

                <section class="mt-5">
                  <label >Data de inicio da promoção</label>
                  <v-text-field
                      style="border-radius: 7.5px"
                      dense
                      height="40"
                      outlined
                      type="date"
                      hide-details
                      v-model="promotionStart"
                  ></v-text-field>
                </section>

                <section class="mt-5" >
                  <label>Data de fim da promoção</label>
                  <v-text-field
                      style="border-radius: 7.5px"
                      dense
                      height="40"
                      outlined
                      type="date"
                      hide-details
                      v-model="promotionEnd"
                  ></v-text-field>
                </section>
              </section>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0">
              <v-btn
                  class="secondary-button mt-5 ml-3"
                  style="height: 40px!important; border-radius: 7.5px!important"
                  height="40"
                  width="100%"
                  elevation="0"
                  :disabled="!action"
                  @click="confirmActionDialog = true"
              >
                {{ action ? actions.find((x) => x.value === action).label : 'Selecione a ação'}}
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-container>

    <!-- Importar Excel -->
    <v-dialog v-model="importDialog" max-width="650px">
      <ImportExcel
        title="Importar Produtos"
        textMessage="Importar arquivos '.xlsx' (Excel) para agilizar o processo de adição de produtos em massa!"
        icone="mdi-arrow-down-circle"
        tipo="Produto"
        @importExc="generateExcel()"
        route="product"
        typeRoute="produtos"
        @close="(importDialog = false), updateTable()"
        @generate="(importDialog = false), updateTable()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Exportar Excel -->
    <v-dialog v-model="excelDialog" max-width="500px">
      <ExcelModal
        title="Exportar Produtos"
        textMessage="Deseja exportar os produtos para excel ?"
        cancelBtn="Cancelar"
        okbtn="Sim, exportar"
        icone="mdi-arrow-up-circle"
        textObservation=""
        @close="excelDialog = false"
        @generate="(excelDialog = false), generateExcel()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Modal deletar -->
    <v-dialog v-model="deleteDialog" max-width="450px">
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que deseja deletar este produto?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation=""
        icone="mdi-restore-alert"
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="action"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === action).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="performAction()"
      />
    </v-dialog>

    <v-dialog v-model="productsCannotBeDeletedDialog" max-width="700">
      <v-card class="d-flex flex-column ma-0 pa-0">
        <h2 class="text-center mt-4">Produtos que não podem serem excluídos</h2>
        <ul class="mx-2 list_style" >
          <li v-for="(item, i) in productsCannotBeDeleted" :key="item.product.productId" class="mt-5">
            <hr v-if="i > 0"/>
            <p class="mb-1">Produto: <strong>{{ item.product.productName }}</strong></p>
            <ul class="list_style">
              <li v-for="motive in item.motives" :key="motive">
                <p class="mb-2"> {{motive}}</p>
              </li>
            </ul>
          </li>
        </ul>

        <section class="d-flex justify-center">
          <v-btn
              class="secondary-button my-3"
              style="height: 40px!important; border-radius: 7.5px!important"
              height="40"
              width="60%"
              elevation="0"
              :disabled="!action"
              @click="productsCannotBeDeletedDialog = false"
          >
            Fechar
          </v-btn>
        </section>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.v-expansion-panel::before {
  box-shadow: none;
}
.config-button {
  transition: 0.3s;
  min-width: 200px;
  width: 45%;
  border-radius: 7.5px !important;
}

.config-button:hover {
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  color: #ffffff !important;
}
.add-button {
  min-width: 200px;
  width: 45%;
  transition: 0.3s;
  font-weight: bold !important;
  font-size: 16px !important;
  color: #ffffff !important;
  background: #bc0000 !important;
  border-radius: 7.5px !important;
}

.add-button:hover {
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.normal {
  font-style: normal;
  font-weight: 300;
  font-size: 15px !important;
  color: #979797;
}

.product-name-field {
  white-space: nowrap !important;
  width: 110px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;

  font-weight: 300;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.15px;
}

.long-name {
  width: 80px !important;
}

.sku-name {
  width: 75px !important;
}

.imgProduct {
  background-position: center center;
  border-radius: 5px;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.02rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.remove-button {
  border: 2px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}

.table-button {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import ImportExcel from "../components/ImportExcel.vue";
import DeleteModal from "../components/DeleteModal.vue";
import Vue from "vue";
import ExcelModal from "../components/ExcelModal.vue";
import { VMoney } from "v-money";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    ConfirmModal,
    Pagination,
    ImportExcel,
    ExcelModal,
    DeleteModal,
  },

  data: () => ({
    outlined: true,
    value: 0.00,
    options: {
      locale: "pt-BR",
      prefix: "%",
      suffix: "",
      length: 11,
      precision: 1
    },
    actions: [
      { label: "Inativar produtos(s)", value: 1},
      { label: "Ativar produtos(s)", value: 2},
      { label: "Inativar SKU(s)", value: 3},
      { label: "Ativar SKU(s)", value: 4},
      { label: "Excluir produtos(s)", value: 5},
      { label: "Diminuir preço do(s) produtos(s)", value: 6},
      { label: "Aumentar preço do(s) produtos(s)", value: 7},
      { label: "Diminuir preço do(s) SKU(s)", value: 8},
      { label: "Aumentar preço do(s) SKU(s)", value: 9},
      { label: "Alterar porcentagem, data início e fim da promoção do(s) produto(s)", value: 10},
    ],
    subActions: [
      { label: "Porcentagem", value: 1},
      { label: "Real", value: 2},
    ],
    action: null,
    percentageOrReal: null,
    promotionPercentage: null,
    promotionStart: null,
    promotionEnd: null,
    selectedProducts: [],
    confirmActionDialog: false,
    productsCannotBeDeleted: [],
    productsCannotBeDeletedDialog: false,
    userlogged: [],
    orders: [
      {
        text: "Crescente",
        value: 0,
      },
      {
        text: "Decrescente",
        value: 1,
      },
    ],
    statusLoading: false,
    panel: true,
    showAllFilters: false,
    maxValueKey: false,
    valueKey: false,
    env_url: "",
    currentProduct: {},
    detailsDialog: false,
    importDialog: false,
    excelDialog: false,
    products: [],
    productsId: [],
    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    show: false,
    dialog: false,
    closeNoLoading: false,
    editDialog: false,
    addDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    //currentProduct: {},
    page: 1,
    totalItems: 1,
    currentPage: 1,
    totalPages: 1,
    pageSize: 20,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 20,
      product: "",
      productCategory: 0,
      productType: "",
      productApplication: "",
      maxValue: "",
      value: "",
      ProductSubCategory: 0,
    },
    error: false,
    message: "",
    headers: [
      {
        text: "Foto",
        class: "item",
        value: "productPic",
        align: "start",
        sortable: false,
      },
      {
        text: "Nome",
        class: "item",
        value: "productName",
        align: "start",
        sortable: false,
      },
      {
        text: "SKU",
        class: "item",
        value: "productSku",
        align: "start",
        sortable: false,
      },
      {
        text: "Categoria",
        class: "item",
        value: "categories",
        align: "start",
        sortable: false,
      },
      {
        text: "Valor",
        class: "item",
        value: "price",
        align: "center",
        sortable: false,
      },
      {
        text: "Vendas",
        class: "item",
        value: "vendas",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        class: "item",
        value: "status",
        align: "center",
        sortable: false,
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headerProps: { sortByText: "Ordenar por" },
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
    categories: [],
    subCategories: [],
  }),
  directives: { money: VMoney },

  async created() {
    await this.getCategories();
    await this.getSubCategories();
    this.productName = null;
    this.productsId = null;
    const jsonFilters = localStorage.getItem("filters");

    if (jsonFilters) {
      this.filter = JSON.parse(localStorage.getItem("filters"));
      this.page = this.filter.page;
    }

    await this.updateTable();

    this.env_url = process.env.VUE_APP_BASE_URL;

    this.userlogged = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.action).label) {
        case 'Inativar produtos(s)':
          this.inactivateProducts()
          break
        case 'Ativar produtos(s)':
          this.activateProducts()
          break
        case 'Inativar SKU(s)':
          this.inactivateSKUs()
          break
        case 'Ativar SKU(s)':
          this.activateSKUs()
          break
        case 'Excluir produtos(s)':
          this.removeProducts()
          break
        case 'Diminuir preço do(s) produtos(s)':
          if (!this.percentageOrReal || !this.value || this.value <= 0){
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Preencha os campos corretamente.",
              trace: null,
            });
            return
          }
          this.decreaseProductPrice()
          break
        case 'Aumentar preço do(s) produtos(s)':
          if (!this.percentageOrReal || !this.value || !this.value <= 0){
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Preencha os campos corretamente.",
              trace: null,
            });
            return
          }
          this.increaseProductPrice()
          break
        case 'Diminuir preço do(s) SKU(s)':
          if (!this.percentageOrReal || !this.value || this.value <= 0){
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Preencha os campos corretamente.",
              trace: null,
            });
            return
          }
          this.decreaseSKUPrice()
          break
        case 'Aumentar preço do(s) SKU(s)':
          if (!this.percentageOrReal || !this.value || this.value <= 0){
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Preencha os campos corretamente.",
              trace: null,
            });
            return
          }
          this.increaseSKUPrice()
          break
        case 'Alterar porcentagem, data início e fim da promoção do(s) produto(s)':
          if (!this.promotionPercentage || !this.promotionStart || !this.promotionEnd){
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Preencha os campos corretamente.",
              trace: null,
            });
            return
          }
          this.updatePromotion()
          break
        default:
      }
    },

    //Inativar produtos(s)
    async inactivateProducts() {
      try {
        const selectedProducts = JSON.parse(JSON.stringify(this.selectedProducts))
        selectedProducts.forEach((x) => {
          x.status = 0;
        })
        await this.apiService
            .put(`product/status/list`, selectedProducts)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {
      }
    },

    //Ativar produtos(s)
    async activateProducts() {
      try {
        const selectedProducts = JSON.parse(JSON.stringify(this.selectedProducts))
        selectedProducts.forEach((x) => {
          x.status = 1;
        })
        await this.apiService
            .put(`product/status/list`, selectedProducts)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {

      }
    },

    //Inativar SKU(s)
    async inactivateSKUs() {
      try {
        const selectedProducts = JSON.parse(JSON.stringify(this.selectedProducts))
        selectedProducts.forEach((x) => {
          x.status = 0;
        })
        await this.apiService
            .put(`product/sku/active/list`, selectedProducts)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos SKUs dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {
      }
    },

    //Ativar SKU(s)
    async activateSKUs() {
      try {
        const selectedProducts = JSON.parse(JSON.stringify(this.selectedProducts))
        selectedProducts.forEach((x) => {
          x.status = 1;
        })
        await this.apiService
            .put(`product/sku/active/list`, selectedProducts)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos SKUs dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {
      }
    },

    //Excluir produtos(s)
    async removeProducts() {
      try {
        const {statusCode, content} = await this.checkProductsToBeExcluded()
        if (content && content.length > 0) {
          this.productsCannotBeDeleted = content;
          this.productsCannotBeDeletedDialog = true;
          return
        }
        await this.apiService
            .post(`product/delete/list`, this.selectedProducts)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Banners excluídos com sucesso!",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    //Diminuir preço do(s) produtos(s)
    async decreaseProductPrice() {
      try {
        const body = {
          increaseOrDecrease: 2,
          products: this.selectedProducts,
          percentageOrReal: this.percentageOrReal,
          value: this.value
        }
        await this.apiService
            .post(`product/price/list`, body)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Preço dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    //Aumentar preço do(s) produtos(s)
    async increaseProductPrice() {
      try {
        const body = {
          increaseOrDecrease: 1,
          products: this.selectedProducts,
          percentageOrReal: this.percentageOrReal,
          value: this.value
        }
        await this.apiService
            .post(`product/price/list`, body)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Preço dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    //Diminuir preço do(s) SKU(s)
    async decreaseSKUPrice() {
      try {
        const body = {
          increaseOrDecrease: 2,
          products: this.selectedProducts,
          percentageOrReal: this.percentageOrReal,
          value: this.value
        }
        await this.apiService
            .post(`product/price/sku/list`, body)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Preço dos SKUs atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    //Aumentar preço do(s) SKU(s)
    async increaseSKUPrice() {
      try {
        const body = {
          increaseOrDecrease: 1,
          products: this.selectedProducts,
          percentageOrReal: this.percentageOrReal,
          value: this.value
        }
        await this.apiService
            .post(`product/price/sku/list`, body)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Preço dos SKUs atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    async updatePromotion() {
      try {
        const body = {
          promotionPercentage: this.promotionPercentage,
          promotionStart: this.promotionStart,
          promotionEnd: `${this.promotionEnd} 23:59:59`,
          products: this.selectedProducts,
        }
        await this.apiService
            .post(`product/promotion/list`, body)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Prmoção dos produtos atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    async checkProductsToBeExcluded() {
      try {
        return await this.apiService.post(`product/check-products-to-be-excluded`, this.selectedProducts)
      } catch (e) {

      }
    },


    addProductsListSelectedProducts(product){
      const productsFind = this.selectedProducts.findIndex((x) => x.productId === product.productId)
      if(productsFind > -1){
        this.selectedProducts.splice(productsFind, 1)
      } else {
        this.selectedProducts.push(product)
      }
    },

    setSubActions() {
      this.options.prefix = this.percentageOrReal === 1 ? "%" : "R$"
      this.options.precision = this.percentageOrReal === 1 ? 1 : 2
    },

    openFilePicker() {
      document.querySelector("#excelSkusInput").click();
    },

    setExcelFile(event) {
      this.loading = true;
      let file;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        file = reader.result;
        this.apiService
          .post("product/skus/excel-import", { file: file })
          .then((resp) => {
            this.$toast.success("Importação feita com sucesso");
            this.loading = false;
          })
          .catch((erro) => {
            this.$toast.error("Erro ao importar o arquivo");
            this.loading = false;
          });
      };
    },

    async getCategories() {
      this.apiService.get("category/list").then((response) => {
        this.categories = response;
      });
    },

    async getSubCategories() {
      this.apiService.get("subCategory/listAll").then((response) => {
        this.subCategories = response;
      });
    },

    async generateExcel() {
      this.loading = true;

      let now = new Date();
      var filename =
        `Produtos_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("product/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          // this.$emit("close");
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: erro.body.message,
            trace: null,
          });
        });
    },

    async generateSkusExcel() {
      this.loading = true;

      let now = new Date();
      var filename =
        `skus_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("product/skus/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          // this.$emit("close");
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: erro.body.message,
            trace: null,
          });
        });
    },

    showSuccess(message) {
      this.$emit("show", message);
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    importExcel(products) {
      this.dialogKey = !this.dialogKey;
      this.importDialog = true;
    },

    detailsProduct(item) {
      this.$router.push({
        path:
          "/add-product?isEditing=true&id=" + item.productId + "&isDetail=true",
        params: item,
      });
    },

    exportExcel(products) {
      this.currentProduct = products;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    async editProduct(item) {
      localStorage.setItem("filters", JSON.stringify(this.filter));
      await this.$router.push({
        path: "/add-product?isEditing=true&id=" + item.productId,
        params: item,
      });
    },

    getColor(category) {
      switch (category) {
        case 0:
          return "gray";

        case 1:
          return "blue";

        case 2:
          return "red";

        default:
          return "yellow";
      }
    },

    changeStatus(item) {
      this.statusLoading = true;

      this.apiService
        .post("product/status", item)
        .then(() => {
          this.statusLoading = false;
        })
        .catch(() => {
          this.statusLoading = false;
        });
    },

    toggleChangeDialog(item) {
      this.approveSelectedItem = item;
      this.currentResale = item;
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.editDialog = false;
      this.updateTable();
    },

    deleteProduct(item) {
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    logProduct(item) {
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.logDialog = true;
    },

    filterTable() {
      this.loading = true;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;

      this.updateTable();
      this.filterDialog = false;
    },

    async updateTable() {
      this.loading = true;

      this.filter.maxValue =
        typeof this.filter.maxValue == "string"
          ? parseFloat(this.filter.maxValue.replace(".", "").replace(",", "."))
          : this.filter.maxValue;

      this.filter.value =
        typeof this.filter.value == "string"
          ? parseFloat(this.filter.value.replace(".", "").replace(",", "."))
          : this.filter.value;

      this.isLoading = true;
      await this.apiService
        .post(`product/list`, this.filter)
        .then((response) => {
          this.totalPages = response.pager.totalPages;
          this.currentPage = response.pager.currentPage;
          this.totalItems = response.pager.totalItems;
          this.products = response.products;
          this.loading = false;
          this.isLoading = false;
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 20,
      };
      this.page = 1;
      this.maxValueKey = !this.maxValueKey;
      this.valueKey = !this.valueKey;

      localStorage.removeItem("filters");

      this.updateTable();
      this.filterDialog = false;
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`product/delete`, this.currentProduct)
        .then(() => {
          this.updateTable();
          this.loading = false;
          this.deleteDialog = false;

          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "sucsess",
            title: "Item removido com sucesso!",
            message: "",
            trace: null,
          });
        })
        .catch((err) => {
          if (err.status != 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível remover o produto.",
              message:
                "Confira se o produto já está associado em algum revendedor.",
              trace: null,
            });
          } else if (err.status == 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Este usuário não tem autorização para concluir a ação.",
              message: "Somente usuários com permissão podem deletar/editar",
              trace: null,
            });
            this.$router.push("/products");
            this.close();
          }

          this.loading = false;
        });
    },
  },

  watch: {
  },
};
</script>
